//
import Model from '@/models/Model'

/**
 * 
 */
export default class WhPack extends Model {

  /**
   * 
   */
  get wh_product_internal_code() {
    return this.getProperty('wh_product.internal_code', '')
  }
  
  /**
   * 
   */
  get wh_product_name() {
    return this.getProperty('wh_product.name', '')
  }
  
  /**
   * 
   */
  get wh_product_sub_family_id() {
    return this.getProperty('wh_product.wh_subfamily_id', '')
  }

  /**
   * 
   */
  mapBranchOffice(item) {
    return {
      g_branch_office_id: item.g_branch_office_id,
      sale_price: Number(item.sale_price || 0),
      cost_price: Number(item.cost_price),
      gains_margin: Number(item.gains_margin || 0),
      critical_stock: Number(item.critical_stock),
      maximum_stock: Number(item.maximum_stock),
      minimum_stock: Number(item.minimum_stock),
      //default_warehouse_id: Number(item.default_warehouse_id || 1),
    }
  }

  /**
   * 
   */
  reset() {

    //
    this.internal_code = this.wh_product_internal_code
    this.name = this.wh_product_name
    this.wh_subfamily_id = this.wh_product_sub_family_id
    this.item_quantity = Number(this.item_quantity)

    //
    return this
  }

  /**
   * 
   */
  resource() {
    return 'wh_pack'
  }
  
  /**
   * 
   */
  toCreate() {

    //
    let clone = this.clone()

    //
    //clone.id = clone.wh_product_id
    clone.branch_office_data = clone.branch_offices.map(this.mapBranchOffice)

    //
    return this.clean([
      'alias_name',
      'branch_office_data',
      'name',
      'internal_code',
      'item_quantity',
      'tags',
      'upc_codes',
      'warranty_days',
      'wh_item_id',
      'wh_subfamily_id',
    ])
  }
  
  /**
   * 
   */
  toUpdate() {

    //
    let clone = this.clone()

    //
    clone.id = clone.wh_product_id
    clone.branch_office_data = clone.branch_offices.map(this.mapBranchOffice)

    //
    return clone.clean([
      'alias_name',
      'branch_office_data',
      'name',
      'internal_code',
      'wh_item_id',
      'id',
      'item_quantity',
      'tags',
      'upc_codes',
      'warranty_days',
      'wh_subfamily_id',
    ])
  }
}